import {
  API_SUCCESS,
  API_FAIL,
  GET_CHARTS_DATA,
  GET_TASK_DATA_FAIL,
  GET_TASK_DATA_SUCCESS,
  APPROVE_TASK_FAIL,
  APPROVE_TASK_SUCCESS,
  TEAM_DASHBOARD_LIST_SUCCESS,
  TEAM_DASHBOARD_LIST_FAIL,
  TEAM_ACTION_SUCCESS,
  TEAM_ACTION_FAIL,
  TEAM_SHIFT_START_ACTION_SUCCESS,
  TEAM_SHIFT_START_ACTION_FAIL,
  TEAM_SHIFT_END_ACTION_SUCCESS,
  TEAM_SHIFT_END_ACTION_FAIL,
  TEAM_TASK_LIST_SUCCESS,
  TEAM_TASK_LIST_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  chartsData: [],
  taskList: [],
  error: [],
  approveRes: [],
  list: [],
  res: [],
};

const Dashboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TEAM_TASK_LIST_SUCCESS:
      return {
        ...state,
        taskList: action.payload,
      };
    case TEAM_TASK_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TEAM_SHIFT_END_ACTION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case TEAM_SHIFT_END_ACTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TEAM_SHIFT_START_ACTION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case TEAM_SHIFT_START_ACTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TEAM_ACTION_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case TEAM_ACTION_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case TEAM_DASHBOARD_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case TEAM_DASHBOARD_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case APPROVE_TASK_SUCCESS:
      return {
        ...state,
        approveRes: action.payload,
      };

    case APPROVE_TASK_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_TASK_DATA_SUCCESS:
      return {
        ...state,
        taskList: action.payload,
      };

    case GET_TASK_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case API_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CHARTS_DATA:
          return {
            ...state,
            chartsData: action.payload.data,
          };
        default:
          return state;
      }
    case API_FAIL:
      switch (action.payload.actionType) {
        case GET_CHARTS_DATA:
          return {
            ...state,
            chartsDataError: action.payload.error,
          };

        default:
          return state;
      }
    default:
      return state;
  }
};

export default Dashboard;
